import { FC } from 'react';
import { Button, Modal, Typography } from 'melp-design/components';
import { useTranslation } from 'react-i18next';
import { ModalProps } from 'store/modal';
import { Stack } from '@mui/material';
import { SystemColors } from 'melp-design/style';
import { Link, QrCode } from '@mui/icons-material';
import { useDownloadPdf, useGenerateQrCodeDataUrl } from 'store/files';
import { QrCodeDocument } from './atoms';

interface Props extends ModalProps {
  url: string;
}

export const ShareModal: FC<Props> = ({ url, closeModal }) => {
  const { t } = useTranslation();

  const { mutate: generateQrCodeDataUrl, isLoading } =
    useGenerateQrCodeDataUrl();
  const { mutate: downloadPdf } = useDownloadPdf();

  return (
    <Modal.Content
      title={t('global.actions.share')}
      actions={[
        {
          onClick: () => closeModal(),
          label: t('buttons.ok'),
        },
      ]}
    >
      <Stack gap={1}>
        <Stack gap={0.5}>
          <Typography>{t('shop.vouchers.redeem.url')}</Typography>
          <Stack
            flexDirection="row"
            alignItems="center"
            justifyContent="space-between"
            gap={2}
            sx={{
              backgroundColor: SystemColors.grey[96],
              p: 1,
              borderRadius: 1,
              color: SystemColors.grey[45],
            }}
          >
            <Typography
              color="inherit"
              sx={{ flex: 1, wordBreak: 'break-all' }}
            >
              {url}
            </Typography>
          </Stack>
        </Stack>

        <Stack flexDirection="row" gap={1} flexWrap="wrap">
          <Button
            label={t('global.actions.copy_link')}
            size="sm"
            variant="neutral-outline"
            icon={Link}
            onClick={() => {
              navigator.clipboard.writeText(url);
            }}
          />
          <Button
            label={t('global.actions.download_qr')}
            size="sm"
            variant="neutral-outline"
            icon={QrCode}
            disabled={isLoading}
            onClick={() => {
              generateQrCodeDataUrl(
                { text: url },
                {
                  onSuccess: (dataUrl) => {
                    return downloadPdf({
                      filename: 'qr-code',
                      document: <QrCodeDocument dataUrl={dataUrl} />,
                    });
                  },
                },
              );
            }}
          />
        </Stack>
      </Stack>
    </Modal.Content>
  );
};
